export const MONTHLY_REVIEW_ICONS = {
  star: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6875 29.7968L28.5625 34.7968C29.5781 35.4375 30.8281 34.4843 30.5312 33.3125L28.25 24.3437C28.1883 24.0951 28.1981 23.8342 28.2783 23.5909C28.3585 23.3476 28.5057 23.1319 28.7031 22.9687L35.7656 17.0781C36.6875 16.3125 36.2187 14.7656 35.0156 14.6875L25.7969 14.0937C25.5453 14.0791 25.3035 13.9915 25.1009 13.8417C24.8984 13.6918 24.7439 13.4862 24.6562 13.25L21.2187 4.59373C21.1278 4.34358 20.962 4.12748 20.744 3.97478C20.5259 3.82208 20.2662 3.74017 20 3.74017C19.7338 3.74017 19.4741 3.82208 19.256 3.97478C19.038 4.12748 18.8722 4.34358 18.7812 4.59373L15.3437 13.25C15.2561 13.4862 15.1016 13.6918 14.899 13.8417C14.6965 13.9915 14.4547 14.0791 14.2031 14.0937L4.98437 14.6875C3.78124 14.7656 3.31249 16.3125 4.23437 17.0781L11.2969 22.9687C11.4943 23.1319 11.6415 23.3476 11.7217 23.5909C11.8019 23.8342 11.8117 24.0951 11.75 24.3437L9.64062 32.6562C9.28124 34.0625 10.7812 35.2031 11.9844 34.4375L19.3125 29.7968C19.518 29.6662 19.7565 29.5968 20 29.5968C20.2435 29.5968 20.482 29.6662 20.6875 29.7968Z"
        fill="currentColor"
      />
    </svg>
  ),
  close: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L15 15M15 1L1 15"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  ),
}
